import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import { DrawerProvider } from "common/contexts/DrawerContext";
import Navbar from "containers/Interior/Navbar";
import Footer from "containers/Interior/Footer";
import Heading from "common/components/Heading";
import { ResetCSS } from "common/assets/css/style";
import merkur from "common/assets/image/interior/merkur.png";
import {
  GlobalStyle,
  InteriorWrapper,
  ContentWrapper,
  BodyWrapper,
} from "containers/Interior/interior.style";
import SEO from "components/seo";

export default () => {
  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <SEO title="Direct4me Click and Collect solution " />
        <ResetCSS />
        <GlobalStyle />

        {/* Start writing your markup from here. */}
        <InteriorWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContentWrapper>
            <BodyWrapper>
              <a href="/newsroom" style={{ color: "#00A5C0" }}>
                <Heading as="h5" content="NEWSROOM" />
              </a>
              <Heading as="h1" content="Direct4me Click and Collect solution" />

              <p>
                <b>
                  Direct4me as the perfect Click and Collect solution for
                  Curbside
                </b>
              </p>
              <p>
                The popularity of curbside pickup services, or curbside click
                and collect services, has grown in recent years, particularly in
                the US market. Covid-19 has seen many retailers favour this
                initiative as it offers a fast, contactless and easy way for
                consumers to pick up online orders. While the service has been
                particularly useful during the downturn, it has also given
                millions of shoppers a convenient channel that they may not want
                to give up, even as restrictions ease. It puts consumers in
                control to consumers by allowing them to pick up goods at a time
                that is convenient for them. By enticing customers into the
                store, it also gives them the opportunity to further interact
                with the brand.
              </p>
              <p>
                But waiting in a queue at an online pick-up or click and collect
                counter poses a task to consumers and employees. Direct4me
                introduces a safe delivery point for customers and couriers or
                employees. Direct4me spaces allow retailers to set up a fully
                automated click and collect point outside their store. The
                spaces are powered by batteries and require no external power
                supply. While the spaces transmit data via selected channels,
                they do not require a built-in communication device (e.g., a SIM
                card, Wi-Fi etc.). Instead, the smart lock uses the connectivity
                of the user's phone to transmit the required user authentication
                information of the users to the backend system. Users can
                securely unlock Direct4me spaces with any phone - smart or
                feature phone and they can use it without any registration.
              </p>
              <p>
                <b>
                  Why should retailers invest in improving curbside pickup with
                  Direct4me spaces?
                </b>
              </p>
              <p>
                Direct4me spaces combine the convenience of online shopping and
                the convenience of local pick up. While it’s a great solution
                for consumers, it’s even better for retailers who can use
                Direct4me to increase their network, increment revenue and brand
                affinity. As a digital platform, Direct4me serves to manage and
                distribute sound keys for unlocking spaces, provides
                traceability for packages and reduces damage to packages during
                delivery.{" "}
              </p>
              <p>
                <b>Merkur Click and Collect locations</b>
              </p>
              <p>
                {" "}
                In order to have the best possible experience both online and
                in-store, Merkur decided to set up Direct4me spaces outside its
                supermarkets. The spaces allow customers to pick up orders
                purchased from the online store without entering the
                supermarket. Direct4me was the best choice for Merkur as
                designing and building a Click & Collect infrastructure from
                scratch is costly and resource intensive, often requiring
                investment in specialised hardware for implementation.
                Direct4me, on the other hand, is an easy-to-implement
                drop-and-play solution that primarily improves ROI for Merkur as
                a business and ensures a contactless, secure experience for
                customers.
              </p>
              <img src={merkur}/>
              <p>
                Click and Collect curbside point in front of Merkur shopping
                center
              </p>
              
            </BodyWrapper>
          </ContentWrapper>
          <Footer />
        </InteriorWrapper>
        {/* End of markup section. */}
      </Fragment>
    </ThemeProvider>
  );
};
